import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import { v4 as uuidv4 } from "uuid";
import Moment from "moment";
import Translate from "components/translate";

import RFSInfo from "../Components/RFSInfo";
import Input from "components/react-validation/components/input";
import Form from "components/react-validation/components/form";
import Textarea from "../../components/react-validation/components/text-area";
import Submit from "../../components/react-validation/components/submit";
import Datetime from "react-datetime";
import Dropzone from "react-dropzone";

import { isEmpty } from "lodash";
import { Dropdown } from "../../components/Dropdown/Dropdown";

import * as LotActionType from "../../Lots/constants";
import * as WOTActionType from "../../Work-Order-Type/constants";
import * as TradeActionType from "../../Trades/constants";
import * as ItemActionType from "../../Items/constants";
import * as SubcontractorActionType from "../../Subcontractors/constants";
import * as ProjectActionType from "../../Projects/constants";
import * as WorkOrderActionType from "../constants";
import * as RFSActionType from "../../Request-Services/constants";
import * as Vali from "helper/validator-helper";

const MAXIMUM_FILE_SIZE = 1024 * 1024 * 10; //10MB
class AddScheduleWorkOrder extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    toggleModal: PropTypes.func,
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    workOrderTypeList: PropTypes.any,
    TradeList: PropTypes.any,
    ItemRepairList: PropTypes.any,
    ProblemList: PropTypes.any,
    RoomList: PropTypes.any,
    SubcontractorList: PropTypes.any,
    UserList: PropTypes.any,
    ManagerStore: PropTypes.object,
    IsRedirectToEdit: PropTypes.object,
    ManageWorkOrderTypes: PropTypes.object,
    UserProfile: PropTypes.object,
  };

  constructor(props) {
    super(props);

    let rfsId = null;

    if (props.match.params.RFSID) {
      rfsId = props.match.params.RFSID;
    }

    this.state = {
      isFetchTrade: false,
      lotStatus: null,

      wot: null,
      trade: null,
      itemRepair: null,
      problem: null,
      room: null,
      subcontractor: null,
      user: null,
      userList: [],

      rfsId: rfsId,

      isCheckAnotherProblem: false,

      appointmentDate: Moment(new Date()).set({ hour: 9, minute: 0 }),

      isModeAssignSub: true,
      isInitialUser: false,
      isLoadingLocation: false,
      isLoadingTrade: false,
      isLoadingSubcontractor: false,
      isLoadingUser: false,
      isLoadingItemToRepair: false,
      isLoadingProblem: false,
      isLoadingWorkOrderType: false,
      error: null,

      files: [],
    };
  }

  componentDidMount() {
    this.fetchLotPaidFeature();
    if (this.props.ManagerStore.ScheduleRequestCreated) {
      if (!this.props.ManagerStore.RFSProfile.project) {
        this.fetchDetailRfs();
      }
      this.props.dispatch({
        type: WorkOrderActionType.SET_IS_REDIRECT_WORK_ORDER_FALSE,
      });
    } else {
      // this.props.history.push(`/request-for-services/${this.state.rfsId}`);
    }
  }

  fetchLotPaidFeature = () => {
    this.props.dispatch({
      type: WorkOrderActionType.GET_LOT_PAID_FEATURE,
      callback: (data, success) => {
        if (success && data.data.length > 0) {
          this.setState({ lotStatus: data.data[0].lotStatus });
        }
      },
    });
  };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.ManagerStore &&
      nextProps.ManagerStore.RFSProfile &&
      nextProps.ManagerStore.RFSProfile.managedByUser &&
      !this.state.isInitialUser
    ) {
      this.setState({
        user: {
          value: nextProps.ManagerStore.RFSProfile.managedByUser.id,
          text: nextProps.ManagerStore.RFSProfile.managedByUser.displayName,
          extensionValue: {
            email: nextProps.ManagerStore.RFSProfile.managedByUser.email,
          },
          selected: false,
        },
        defaultUser: {
          value: nextProps.ManagerStore.RFSProfile.managedByUser.id,
          text: nextProps.ManagerStore.RFSProfile.managedByUser.displayName,
          extensionValue: {
            email: nextProps.ManagerStore.RFSProfile.managedByUser.email,
          },
          selected: false,
        },
        isInitialUser: true,
      });
    }
    if (nextProps.IsRedirectToEdit.isRedirect) {
      if (this.state.isCheckAnotherProblem) {
        this.onResetForm();
      } else {
        this.props.history.push(
          `/request-for-services/work-order/detail/${this.state.rfsId}/${nextProps.IsRedirectToEdit.refNo}`
        );
      }
    }

    if (nextProps.RoomList) {
      this.setState({ isLoadingLocation: false });
    }
    if (nextProps.TradeList) {
      this.setState({ isLoadingTrade: false });
    }
    if (nextProps.SubcontractorList) {
      this.setState({ isLoadingSubcontractor: false });
    }
    if (nextProps.UserList) {
      this.setState({ isLoadingUser: false });
    }
    if (nextProps.ItemRepairList) {
      this.setState({ isLoadingItemToRepair: false });
    }
    if (nextProps.ProblemList) {
      this.setState({ isLoadingProblem: false });
    }
    if (nextProps.workOrderTypeList) {
      this.setState({ isLoadingWorkOrderType: false });
    }
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: RFSActionType.ADD_SCHEDULE_RFS_SUCCESS,
      data: { data: null },
    });
  }

  onResetForm = () => {
    this.setState({
      wot: null,
      trade: null,
      itemRepair: null,
      problem: null,
      room: null,
      subcontractor: null,
      user: null,
      appointmentDate: null,
      isCheckAnotherProblem: false,
      files: [],
      errorFile: null,
    });

    if (this.form) {
      this.form.resetForm(this.refs);
    }
    this.props.dispatch({
      type: WorkOrderActionType.SET_IS_REDIRECT_WORK_ORDER_FALSE,
    });
  };

  fetchDetailRfs() {
    this.props.dispatch({
      type: RFSActionType.GET_BY_RFS_ID_ASYNC,
      params: this.state.rfsId,
    });
  }

  handleCreateAnother = (e) => {
    this.setState(
      {
        isCheckAnotherProblem: true,
      },
      () => {
        this.onSubmit(e);
      }
    );
  };

  isDisabledBtn = () => {
    let isDisabled = true;
    if (this.form) {
      const { room, error } = this.state;
      const formValues = this.form.getValues();
      const { title, description } = formValues;
      isDisabled = !room || error || !title || !description;
    }
    this.setState({
      isDisabledAnotherBtn: isDisabled,
    });
  };

  onSelectChange = (event, name) => {
    this.setState({
      [name]: event.value,
    });
    if (name === "itemRepair") {
      this.setState({
        problem: null,
      });
    }
    if (name === "trade") {
      this.setState({
        subcontractor: null,
        itemRepair: null,
        problem: null,
      });
    }
  };

  onChangeAppointmentDate = (appointmentDate) => {
    if (appointmentDate) {
      if (Moment(appointmentDate, "MM/DD/YYYY hh:mm A", true).isValid()) {
        this.setState({
          appointmentDate,
          error: null,
        });
      } else {
        this.setState({
          error: "Invalid datetime.",
        });
      }
    } else {
      this.setState({
        appointmentDate,
        error: null,
      });
    }
  };

  fetchRoom = () => {
    this.setState({ isLoadingLocation: true });
    this.props.dispatch({
      type: LotActionType.SELECT_ROOM_ASYNC,
      params: {
        id: this.props.ManagerStore.RFSProfile.lot.id,
        searchKey: "",
        selectedValue: "",
        includeSystemRoom: true,
      },
    });
  };

  fetchTrade = () => {
    this.setState({ isLoadingTrade: true });
    this.props.dispatch({
      type: LotActionType.SELECT_TRADE_ASYNC,
      params: {
        id: this.props.ManagerStore.RFSProfile.lot.id,
        searchKey: "",
        selectedValue: "",
        setDefaultSelected: false,
      },
    });
  };

  fetchWOT = () => {
    this.setState({ isLoadingWorkOrderType: true });
    this.props.dispatch({
      type: WOTActionType.SELECT_LIST_WOT_ASYNC,
      params: {
        searchKey: "",
        selectedValue: "",
        setDefaultSelected: false,
      },
    });
  };

  fetchItemRepair = () => {
    if (this.state.trade) {
      this.setState({ isLoadingItemToRepair: true });
      this.props.dispatch({
        type: TradeActionType.SELECT_LIST_ITEM_REPAIR_BY_TRADEID_ASYNC,
        params: {
          id: this.state.trade.value,
          searchKey: "",
          selectedValue: "",
          setDefaultSelected: false,
        },
      });
    }
  };

  fetchSubcontractor = () => {
    if (this.state.trade) {
      this.setState({ isLoadingSubcontractor: true });
      this.props.dispatch({
        type: SubcontractorActionType.SELECT_LIST_SUBCONTRACTOR_ASYNC,
        params: {
          projectId: this.props.ManagerStore.RFSProfile.project.id,
          lotId: this.props.ManagerStore.RFSProfile.lot.id,
          tradeId: this.state.trade.value,
          param: {
            searchKey: "",
            selectedValue: "",
          },
        },
      });
    }
  };

  fetchUser = () => {
    this.setState({ isLoadingUser: true });
    this.props.dispatch({
      type: ProjectActionType.GET_LIST_USER_ASYNC,
      params: {
        projectId: this.props.ManagerStore.RFSProfile.project.id,
      },
      callback: () => {
        this.setState({ isFetchedUser: true });
      },
    });
  };

  fetchProblem = () => {
    if (this.state.itemRepair) {
      this.setState({ isLoadingProblem: true });
      this.props.dispatch({
        type: ItemActionType.SELECT_LIST_PROBLEM_ASYNC,
        params: {
          id: this.state.itemRepair.value,
          searchKey: "",
        },
      });
    }
  };

  userTemplate = (item) => {
    if (item.value) {
      return item.text + " (" + item.extensionValue.email + ")";
    }
    return null;
  };

  onSelect = () => {
    this.upload.upload();
  };

  handleCancel = () => {
    this.props.history.push(`/request-for-services/${this.state.rfsId}`);
  };

  handleModeAssign = (mode) => {
    if (mode === "sub") {
      this.setState({ isModeAssignSub: true, user: this.state.defaultUser });
    } else {
      this.setState({ isModeAssignSub: false, subcontractor: null });
    }
  };

  renderInternalUserDropdown = () => {
    if (this.props.UserProfile.sso) {
      return (
        <Dropdown
          onChange={(ref) => {
            this.onSelectChange(ref, "user");
          }}
          filter={true}
          className="filestring-dropdown filter-dropdown"
          onRemote={this.fetchUser}
          options={
            this.state.isFetchedUser
              ? this.props.UserList
              : [{ ...this.state.user }]
          }
          loading={this.state.isLoadingUser}
          itemTemplate={this.userTemplate}
          labelTemplate={this.userTemplate}
          optionLabel="text"
          value={this.state.user}
          showClear={true}
          groupLabels={[
            {
              label: "System users",
              field: "sso",
              condition: [true],
            },
            {
              label: "Builder users",
              field: "sso",
              condition: [false, null],
            },
          ]}
          name="user"
          placeholder="--Select a user"
          style={{ width: "100%", paddingLeft: 15 }}
        />
      );
    }
    return (
      <Dropdown
        onChange={(ref) => {
          this.onSelectChange(ref, "user");
        }}
        filter={true}
        className="filestring-dropdown filter-dropdown"
        onRemote={this.fetchUser}
        options={
          this.state.isFetchedUser
            ? this.props.UserList
            : [{ ...this.state.user }]
        }
        loading={this.state.isLoadingUser}
        itemTemplate={this.userTemplate}
        labelTemplate={this.userTemplate}
        optionLabel="text"
        value={this.state.user}
        showClear={true}
        name="user"
        placeholder="--Select a user"
        style={{ width: "100%", paddingLeft: 15 }}
      />
    );
  };

  onSubmit = (e) => {
    e.preventDefault();

    if (isEmpty(this.state.files)) {
      this.createOrder();
    } else {
      this.uploadAttachmentsToS3(this.state.files, this.createOrder);
    }
  };

  createOrder = (uploadedFiles = []) => {
    const formValues = this.form.getValues();
    const {
      room,
      trade,
      wot,
      subcontractor,
      user,
      itemRepair,
      problem,
      rfsId,
      appointmentDate,
      isModeAssignSub,
    } = this.state;

    let assignedUserId = null;
    let subcontractorId = null;

    if (isModeAssignSub) {
      subcontractorId = subcontractor ? subcontractor.value : null;
    } else {
      assignedUserId = user ? user.value : null;
    }

    const params = {
      title: formValues.title,
      description: formValues.description,
      requestId: rfsId,
      tradeId: trade ? trade.value : null,
      roomId: room.value,
      itemToRepairId: itemRepair ? itemRepair.value : null,
      workOrderTypeId: wot ? wot.value : null,
      problemId: problem ? problem.value : null,
      appointmentDate: appointmentDate
        ? Moment(appointmentDate).format()
        : null,
      attachments: uploadedFiles.map((f) => ({
        url: f.Location,
        key: f.Key,
        fileName: f.name,
      })),
    };

    if (subcontractorId) {
      params.subcontractorId = subcontractorId;
    }

    if (assignedUserId) {
      params.assignedUserId = assignedUserId;
    }

    this.props.dispatch({
      type: WorkOrderActionType.CREATE_SCHEDULE_WORK_ORDER_ASYNC,
      params: {
        data: params,
        isRedirectToEdit: true,
      },
    });
  };

  uploadAttachmentsToS3 = (files, callback) => {
    let uploadedFiles = [];
    this.props.dispatch({
      type: WorkOrderActionType.SETUP_AWS_S3_ASYNC,
      params: { resourcePath: "work-order" },
      callback: () => {
        files.map((file) => {
          this.props.dispatch({
            type: WorkOrderActionType.UPLOAD_FILE_WORK_ORDER_ASYNC,
            params: {
              file: file,
              config: this.props.WorkOrderCredentials,
            },
            callback: (status, result) => {
              if (status === true) {
                result.data.name = file.name;
                uploadedFiles.push(result.data);

                if (uploadedFiles.length === files.length) {
                  callback(uploadedFiles);
                }
              }
            },
          });
        });
      },
    });
  };

  onDropOnAttachments = (droppedFiles) => {
    const { files } = this.state;

    //check maximum is 3 files
    if (files.length + droppedFiles.length > 3) {
      this.setState({ errorFile: "Maximum 3 files allowed." });
    } else {
      let errorFile = null;
      let currentFiles = [...files];

      // show error message when existing one or more file larger than 10MB
      droppedFiles.map((file) => {
        if (file.size > MAXIMUM_FILE_SIZE) {
          errorFile = "File size must not exceed 10MB.";
        } else {
          file["id"] = uuidv4();
          currentFiles.push(file);
        }
      });

      this.setState({
        files: currentFiles,
        errorFile: errorFile,
      });
    }
  };

  renderRequestHomeOwner() {
    // const { RFSProfile } = this.state;

    return (
      <div className="form-group">
        <div className="col-sm-12">
          <span className="text-danger">
            This request is generated by <Translate translateKey="homeowner" />
          </span>
        </div>
      </div>
    );
  }

  validateAssignedTo(user, subcontractor) {
    if (this.state.isModeAssignSub) {
      return !subcontractor;
    }
    return !user;
  }

  renderNewWorkOrder() {
    const {
      room,
      error,
      trade,
      itemRepair,
      wot,
      user,
      subcontractor,
      problem,
    } = this.state;
    const disabled =
      !room ||
      error ||
      !wot ||
      !trade ||
      !itemRepair ||
      this.validateAssignedTo(user, subcontractor) ||
      !problem;
    return (
      <div className="work-order-info-wrapper box-form-siteone col-xs-12 col-lg-12 add-wo-form">
        <div className="wo-general-info clearfix">
          <div className="row">
            <label
              className="col-sm-12 control-label form-siteone-label"
              style={{
                textTransform: "initial",
                fontSize: "16px",
                fontWeight: 500,
                marginBottom: "20px",
                color: "#c0c0c0",
              }}
            >
              Work order details
            </label>
          </div>
          <div className="row col-lg-12 col-sm-12">
            <div className="col-sm-6" style={{ paddingLeft: 0 }}>
              <label className="col-sm-12 control-label form-siteone-label">
                Work order type <span className="text-danger"> *</span>
              </label>
              <div className="col-sm-12">
                <Dropdown
                  onChange={(ref) => {
                    this.onSelectChange(ref, "wot");
                  }}
                  className="filestring-dropdown filter-dropdown"
                  onRemote={this.fetchWOT}
                  options={this.props.workOrderTypeList}
                  loading={this.state.isLoadingWorkOrderType}
                  optionLabel="text"
                  value={this.state.wot}
                  showClear={true}
                  name="workOrderType"
                  placeholder="-- Please select"
                  style={{ width: "100%", paddingLeft: 15 }}
                />
              </div>
            </div>
          </div>

          <div className="row col-sm-12">
            <div className="col-sm-6" style={{ paddingLeft: 0 }}>
              <label className="col-sm-12 control-label form-siteone-label">
                Location <span className="text-danger">*</span>
              </label>
              <div className="col-sm-12">
                <Dropdown
                  onChange={(ref) => {
                    this.onSelectChange(ref, "room");
                  }}
                  filter={true}
                  className="filestring-dropdown filter-dropdown"
                  onRemote={this.fetchRoom}
                  options={this.props.RoomList}
                  optionLabel="text"
                  value={this.state.room}
                  loading={this.state.isLoadingLocation}
                  showClear={true}
                  name="room"
                  placeholder="-- Please select"
                  style={{ width: "100%", paddingLeft: 15 }}
                />
              </div>
            </div>
          </div>
          <div className="row col-sm-12">
            <div className="col-sm-6 select-trade">
              <label className="col-sm-12 control-label form-siteone-label">
                Trade <span className="text-danger"> *</span>
              </label>
              <div className="col-sm-12">
                <Dropdown
                  onChange={(ref) => {
                    this.onSelectChange(ref, "trade");
                  }}
                  filter={true}
                  className="filestring-dropdown filter-dropdown"
                  options={this.props.TradeList}
                  optionLabel="text"
                  onRemote={this.fetchTrade}
                  value={this.state.trade}
                  loading={this.state.isLoadingTrade}
                  showClear={true}
                  name="trade"
                  placeholder="-- Please select"
                  style={{ width: "100%", paddingLeft: 15 }}
                />
              </div>
            </div>
            {this.state.lotStatus && (
              <div className="col-sm-6 select-assigned">
                <div
                  className="col-sm-12 control-label form-siteone-label"
                  style={{ marginBottom: 5 }}
                >
                  Assigned to <span className="text-danger"> *</span>
                  <div
                    className="btn-group btn-group-sm wo-assign-btn-group"
                    role="group"
                  >
                    <button
                      type="button"
                      className={
                        "btn btn-secondary " +
                        (this.state.isModeAssignSub ? "active" : "")
                      }
                      onClick={() => {
                        this.handleModeAssign("sub");
                      }}
                    >
                      subcontractor
                    </button>
                    <button
                      type="button"
                      className={
                        "btn btn-secondary " +
                        (!this.state.isModeAssignSub ? "active" : "")
                      }
                      onClick={() => {
                        this.handleModeAssign("user");
                      }}
                    >
                      internal user
                    </button>
                  </div>
                </div>
                <div className="col-sm-12" style={{ paddingRight: 0 }}>
                  {this.state.isModeAssignSub ? (
                    <Dropdown
                      onChange={(ref) => {
                        this.onSelectChange(ref, "subcontractor");
                      }}
                      filter={true}
                      className="filestring-dropdown filter-dropdown"
                      onRemote={this.fetchSubcontractor}
                      options={
                        this.state.trade ? this.props.SubcontractorList : []
                      }
                      optionLabel="text"
                      value={this.state.subcontractor}
                      loading={this.state.isLoadingSubcontractor}
                      disabled={!this.state.trade}
                      showClear={true}
                      name="subcontractor"
                      placeholder="-- Select a trade first"
                      style={{ width: "100%", paddingLeft: 10 }}
                    />
                  ) : (
                    this.renderInternalUserDropdown()
                  )}
                </div>
              </div>
            )}
          </div>
          <div className="row col-sm-12">
            <div
              className="col-sm-6"
              style={{ paddingLeft: 0, paddingRight: 15 }}
            >
              <label className="col-sm-12 control-label form-siteone-label">
                Item to repair<span className="text-danger"> *</span>
              </label>
              <div className="col-sm-12">
                <Dropdown
                  onChange={(ref) => {
                    this.onSelectChange(ref, "itemRepair");
                  }}
                  filter={true}
                  className="filestring-dropdown filter-dropdown"
                  options={this.state.trade ? this.props.ItemRepairList : []}
                  optionLabel="text"
                  onRemote={this.fetchItemRepair}
                  loading={this.state.isLoadingItemToRepair}
                  value={this.state.itemRepair}
                  disabled={!this.state.trade}
                  showClear={true}
                  name="itemToRepair"
                  placeholder="-- Select a trade first"
                  style={{ width: "100%", paddingLeft: 15 }}
                />
              </div>
            </div>
            <div className="col-sm-6" style={{ paddingLeft: 0 }}>
              <label className="col-sm-12 control-label form-siteone-label">
                Problem <span className="text-danger"> *</span>
              </label>
              <div className="col-sm-12">
                <Dropdown
                  onChange={(ref) => {
                    this.onSelectChange(ref, "problem");
                  }}
                  className="filestring-dropdown filter-dropdown"
                  options={this.state.itemRepair ? this.props.ProblemList : []}
                  optionLabel="text"
                  onRemote={this.fetchProblem}
                  loading={this.state.isLoadingProblem}
                  value={this.state.problem}
                  disabled={!this.state.itemRepair}
                  showClear={true}
                  name="problem"
                  placeholder="-- Select an item to repair first"
                  style={{ width: "100%", paddingLeft: 15 }}
                />
              </div>
            </div>
          </div>

          <div className="row col-sm-12 form-group" style={{ marginBottom: 5 }}>
            <label className="col-sm-12 control-label form-siteone-label">
              Summary<span className="text-danger"> *</span>
            </label>
            <div className="col-sm-12" style={{ padding: "0 15px" }}>
              <Input
                type="text"
                name="title"
                ref="title"
                className="form-control"
                max="200"
                maxLength="200"
                errorMsg="Summary is maximum 200 characters"
                validations={[Vali.required, Vali.maxlength]}
              />
            </div>
          </div>

          <div className="row col-sm-12 form-group" style={{ marginBottom: 5 }}>
            <label className="col-sm-12 control-label form-siteone-label">
              Description
            </label>
            <div className="col-sm-12" style={{ padding: "0 15px" }}>
              <Textarea
                className="form-control"
                name="description"
                ref="description"
                max="1000"
                maxLength="1000"
                errorMsg="Description is maximum 1000 characters"
                style={{ height: 130 }}
                validations={[Vali.maxlength]}
              />
            </div>
          </div>

          <div className="row col-sm-12 form-group">
            <label className="col-sm-12 control-label form-siteone-label">
              Appointment
            </label>
            <div className="col-sm-4" style={{ padding: "0 15px" }}>
              <Datetime
                ref={(ref) => {
                  this.appointmentDate = ref;
                }}
                name="appointmentDate"
                inputProps={{ placeholder: "mm/dd/yyyy hh:mm" }}
                value={this.state.appointmentDate}
                onChange={this.onChangeAppointmentDate}
                closeOnSelect={true}
              />
              {this.state.error && (
                <span className="text-danger" style={{ fontSize: 12 }}>
                  {this.state.error}
                </span>
              )}
            </div>
          </div>

          <div className="row col-sm-12 form-group">
            <label className="col-sm-12 control-label form-siteone-label">
              Attachment
            </label>
            <Dropzone
              disableClick
              style={{ position: "initial" }}
              ref={(ref) => {
                this.dropzoneRef = ref;
              }}
              onDrop={this.onDropOnAttachments}
            >
              <span
                className="add-new-attachment-label"
                style={{ marginLeft: 15 }}
                onClick={(e) => this.dropzoneRef.open()}
              >
                + Add new attachment
              </span>
            </Dropzone>
            {this.state.errorFile && (
              <div
                className="text-danger"
                style={{ marginLeft: 15, fontSize: 12 }}
              >
                {this.state.errorFile}
              </div>
            )}
            {this.state.files.map((f) => (
              <div key={f.name} style={{ marginLeft: 15 }}>
                <span style={{ fontStyle: "italic" }}>{f.name}</span>
                <i
                  className="fa fa-trash"
                  style={{ cursor: "pointer", marginLeft: 15 }}
                  onClick={() => this.onClickTrashIcon(f)}
                />
              </div>
            ))}
          </div>

          <ul className="wo-detail-bottom-btn">
            <li>
              <span
                className="btn btn-primary btn-siteone-default"
                onClick={this.handleCancel}
              >
                Cancel
              </span>
            </li>
            <li>
              <Submit
                className="btn btn-primary btn-submit btn-siteone"
                disabled={disabled}
              >
                Create
              </Submit>
            </li>
            <li>
              <Submit
                className="btn btn-primary btn-siteone"
                type="button"
                disabled={disabled}
                onClick={this.handleCreateAnother}
              >
                Save and create another
              </Submit>
            </li>
          </ul>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="rfs-detail add-new-work-order">
        <div className="page-title clearfix">
          <h2 className="pull-left">Add new Work order</h2>
        </div>
        <ul className="breadcrumb">
          <li>
            <Link to={"/request-for-services"}>Requests for service</Link>
          </li>
          <li>
            <Link to={`/request-for-services/${this.state.rfsId}`}>
              RFS # {this.state.rfsId}
            </Link>
          </li>
          <li className="breadcrumb-siteone-li">Add new work order</li>
        </ul>
        <div className="wrapper">
          {this.props.ManagerStore.RFSProfile &&
            this.props.ManagerStore.RFSProfile.project && (
              <RFSInfo
                RFSInformation={this.props.ManagerStore.RFSProfile}
                location={this.props.location}
                history={this.props.history}
                mode="rfs"
              />
            )}
          <div className="wrapper-form">
            <Form
              className="form-horizontal"
              ref={(ref) => {
                this.form = ref;
              }}
              onSubmit={this.onSubmit}
            >
              {this.renderNewWorkOrder()}
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    UserProfile: state.UserStore.UserProfile,
    ManagerStore: state.RFSStore,
    workOrderTypeList: state.WorkOrderTypesStore.WOTList,
    TradeList: state.LotStore.TradeList,
    ItemRepairList: state.TradeStore.ItemRepairList,
    ProblemList: state.ItemRepairStore.ProblemList,
    RoomList: state.LotStore.RoomList,
    SubcontractorList: state.SubcontractorStore.SubcontractorList,
    UserList: state.ProjectStore.UserSelectList,
    IsRedirectToEdit: state.WorkOrderReducer.IsRedirectToEdit,
    WorkOrderCredentials: state.WorkOrderReducer.Credentials,
  };
};

export default connect(mapStateToProps)(AddScheduleWorkOrder);



// WEBPACK FOOTER //
// ./src/Work-Orders/Containers/add-schedule-work-order.js